/**
 * HW Accordion — drawer mode initialiser.
 * Loaded as an external asset (cached by the browser).
 *
 * Wires .hw-accordion-row__drawer-btn to open the row's dialog-component
 * when the parent container has data-hw-display="drawer".
 *
 * Content is moved from .details-content into .hw-accordion-drawer__body
 * on first open to avoid duplicate content_for 'blocks' rendering.
 */
/**
   * HW Accordion — Drawer mode initialiser.
   *
   * Wires the .hw-accordion-row__drawer-btn to open the row's dialog-component
   * when the parent container has data-hw-display="drawer".
   *
   * Content is moved from .details-content into .hw-accordion-drawer__body on
   * first open to avoid duplicate content_for 'blocks' rendering.
   */
  function initHwAccordionDrawers() {
    const rows = document.querySelectorAll('[data-hw-display="drawer"] accordion-custom');

    rows.forEach((row) => {
      const triggerBtn     = row.querySelector('.hw-accordion-row__drawer-btn');
      const dialogComp     = row.querySelector('dialog-component');
      const drawerBody     = row.querySelector('.hw-accordion-drawer__body');
      const accordionContent = row.querySelector('.details-content');

      if (!triggerBtn || !dialogComp) return;

      let contentMoved = false;

      triggerBtn.addEventListener('click', () => {
        // Move block content into drawer body once
        if (!contentMoved && accordionContent && drawerBody) {
          while (accordionContent.firstChild) {
            drawerBody.appendChild(accordionContent.firstChild);
          }
          contentMoved = true;
        }

        dialogComp.showDialog?.();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHwAccordionDrawers);
  } else {
    initHwAccordionDrawers();
  }
